module.exports = __webpack_public_path__ + "static/hero-804eff0dfab488e8a1b9897672748799.svg";